export class PrivacyPolicyDTO {
  policyName: string;
  policyLanguage: string;
  application: string;
  machineIp: string;
  deviceDetails: string;
  domain: string;
  userId: string;
  email: string;
  userAction: string;
  entDt: string;
}
